<template>
	<Loader v-if="loading" />
	<div v-else>
		<h1>Transaction {{ transaction.id }}</h1>

		<div v-if="transaction.on_hold" class="margin-bottom margin-top error">
			<strong>Payment is on hold</strong>
		</div>

		<div class="margin-top input-row small-margin-bottom">
			<span class="label">Created</span>
			<div><Format type="date" :time="true" :value="transaction.created_at" /></div>
		</div>
		<div class="input-row small-margin-bottom">
			<span class="label">Order</span>
			<div>
				<OrderLink :id="transaction.order_id" />
			</div>
		</div>
		<div class="input-row small-margin-bottom">
			<span class="label">Amount for capture</span>
			<div><Format type="number" :value="transaction.amount_ready_for_capture" /></div>
		</div>
    <div class="input-row small-margin-bottom">
      <span class="label">Explanation</span>
      <div>
        <template v-if="!transaction.explanations.length">N/A</template>
        <template v-else>Amount for capture is 0 because:</template>
        <div
          v-for="e in transaction.explanations">{{ e.message }}</div>
      </div>
    </div>
		<div class="input-row small-margin-bottom">
			<span class="label">Process attempted</span>
			<div><Format type="date" :time="true" :value="transaction.process_attempted_at" /></div>
		</div>
		<div class="input-row small-margin-bottom">
			<span class="label">Processed</span>
			<div><Format type="date" :time="true" :value="transaction.processed_at" /></div>
		</div>
		<div class="input-row small-margin-bottom">
			<span class="label">On hold</span>
			<div>{{ transaction.on_hold ? 'Yes' : 'No' }}</div>
		</div>
		<div class="input-row small-margin-bottom">
			<span class="label">Delay until</span>
			<div class="flex">
				<input class="small-margin-right" type="date" v-model="transaction.delay_until" />
				<button :disabled="saving" class="small gray" v-on:click="transaction.delay_until = null;">Reset</button>
				<button :disabled="saving" class="small small-margin-left" v-on:click="save()">Save</button>
			</div>
		</div>

		<div class="margin-top">
			<button :disabled="saving" v-if="!transaction.processed_at" v-on:click="process()">Process</button>
			<button :disabled="saving" v-if="transaction.processed_at" v-on:click="reopen()">Re-open</button>

			<button
				class="small-margin-left"
				:disabled="saving"
				v-if="!transaction.processed_at && !transaction.on_hold"
				v-on:click="putOnHold()">
					Put on hold
			</button>

			<button
				class="small-margin-left"
				:disabled="saving"
				v-if="!transaction.processed_at && transaction.on_hold"
				v-on:click="releaseFromHold()">
					Release from hold
			</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    transaction: {}
  }),
  computed: {
    ...mapGetters([])
  },
  methods: {
    putOnHold () {
      Vue.$api.post('/queued-transaction/' + this.id + '/put-on-hold', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    releaseFromHold () {
      Vue.$api.post('/queued-transaction/' + this.id + '/release-from-hold', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    process () {
      Vue.$api.post('/queued-transaction/' + this.id + '/process', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    reopen () {
      Vue.$api.post('/queued-transaction/' + this.id + '/reopen', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    save () {
      Vue.$api.patch('/queued-transaction/' + this.id, {
        delay_until: this.transaction.delay_until
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    load () {
      Vue.$api.get('/queued-transaction/' + this.id + '?amount_ready_for_capture=1', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      if (data.delay_until) {
        data.delay_until = data.delay_until.substr(0, 10)
      }

      this.transaction = data
    }
  },
  created () {
    this.load()
  }
}
</script>
